"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Returns an object with the consent status of all purposes.
 */
function getAll() {
    return (0, get_zaraz_1.getZaraz)().consent.getAll();
}
exports.getAll = getAll;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWFsbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zZW50L2dldC1hbGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0RBQWdEO0FBRWhEOztHQUVHO0FBQ0gsU0FBZ0IsTUFBTTtJQUNwQixPQUFPLElBQUEsb0JBQVEsR0FBRSxDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQztBQUNyQyxDQUFDO0FBRkQsd0JBRUMifQ==